import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import StudentModals from "../../studentModals";
import StudentSidebar from "../../student-details/studentSidebar";
import StudentBreadcrumb from "../../student-details/studentBreadcrumb";
import { useGetStudentByIdQuery } from "../../api/studentApi";
import { useStudentInvoices } from "./hooks/useStudentInvoices";
import { useRazorpayPayment } from "./hooks/useRazorpayPayment";
import { showToast } from "../../../../../core/utils/alert";
import PaymentDetails from "./components/paymentDetails";

const StudentFees = () => {
  const routes = all_routes;
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const {
    data: studentResponse,
    isLoading: studentLoading,
    error: studentError,
  } = useGetStudentByIdQuery({ id: id || "" });

  const {
    invoiceRows,
    isLoading: invoiceLoading,
    error: invoiceError,
    refetch: refetchInvoices,
    summary,
  } = useStudentInvoices(id || "");

  // console.log(invoiceRows, 'InvoiceRows')

  const [selectedInvoices, setSelectedInvoices] = useState<number[]>([]);

  // console.log(invoiceRows, 'ir---')

  const { startPayment, isCreating, isVerifying } = useRazorpayPayment();

  const handleCollectFeeSingle = (invoiceRow: any) => {
    if (!student?.id || !student?.center.id) return;

    // Calculate paid amount from student_payments
    const paidAmount =
      invoiceRow.student_payments && invoiceRow.student_payments.length > 0
        ? invoiceRow.student_payments.reduce(
          (sum: any, payment: any) =>
            payment.payment_status === "completed"
              ? sum + payment.amount
              : sum,
          0
        )
        : 0;

    // Calculate pending amount
    const pendingAmount = invoiceRow.payable - paidAmount;

    // Navigate to PaymentDetails with necessary props
    navigate(routes.paymentFeeDetails, {
      state: {
        student,
        invoice: invoiceRow.id,
        totalAmount: pendingAmount,
      },
    });
  };

  if (studentLoading || invoiceLoading) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <StudentBreadcrumb studentId={id} />
          </div>
          <div className="row">
            <StudentSidebar />
            <div className="col-xxl-9 col-xl-8">
              <div className="row">
                <div className="col-md-12">
                  {/* Navigation Tabs */}
                  <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                    <li>
                      <Link
                        to={`${routes.studentDetail.replace(":id", id || "")}`}
                        className="nav-link"
                      >
                        <i className="ti ti-school me-2" />
                        Student Details
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentAttendanceDetail.replace(
                          ":id",
                          id || ""
                        )}`}
                        className="nav-link"
                      >
                        <i className="ti ti-calendar-due me-2" />
                        Attendance
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentFees.replace(":id", id || "")}`}
                        className="nav-link active"
                      >
                        <i className="ti ti-report-money me-2" />
                        Fees
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentResult.replace(":id", id || "")}`}
                        className="nav-link"
                      >
                        <i className="ti ti-bookmark-edit me-2" />
                        Results
                      </Link>
                    </li>
                  </ul>

                  <div className="card">
                    <div className="card-body p-0 py-3">
                      <div className="text-center">
                        Loading student fee data...
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (studentError || invoiceError) {
    return (
      <>
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <StudentBreadcrumb studentId={id} />
            </div>
            <div className="row">
              <StudentSidebar />
              <div className="col-xxl-9 col-xl-8">
                <div className="row">
                  <div className="col-md-12">
                    {/* Navigation Tabs */}
                    <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                      <li>
                        <Link
                          to={`${routes.studentDetail.replace(
                            ":id",
                            id || ""
                          )}`}
                          className="nav-link"
                        >
                          <i className="ti ti-school me-2" />
                          Student Details
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`${routes.studentAttendanceDetail.replace(
                            ":id",
                            id || ""
                          )}`}
                          className="nav-link"
                        >
                          <i className="ti ti-calendar-due me-2" />
                          Attendance
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`${routes.studentFees.replace(":id", id || "")}`}
                          className="nav-link active"
                        >
                          <i className="ti ti-report-money me-2" />
                          Fees
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`${routes.studentResult.replace(
                            ":id",
                            id || ""
                          )}`}
                          className="nav-link"
                        >
                          <i className="ti ti-bookmark-edit me-2" />
                          Results
                        </Link>
                      </li>
                    </ul>

                    {/* Show the error message centered */}
                    <div
                      className="card"
                      style={{ height: "calc(100vh - 300px)" }}
                    >
                      <div className="card-body d-flex align-items-center justify-content-center">
                        <div className="text-center">
                          <div className="mb-3">
                            <i className="ti ti-file-invoice fa-3x text-primary"></i>
                          </div>
                          <h4 className="mb-2">Invoices Not Generated</h4>
                          <p className="text-muted mb-4">
                            It looks like invoices have not been generated for
                            this student yet.
                          </p>
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              navigate(routes.generateInvoices);
                            }}
                          >
                            <i className="ti ti-plus me-2"></i>
                            Generate Invoices
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <StudentModals />
      </>
    );
  }

  // Navigate to invoice when stage is clicked
  const handleStageClick = (invoiceId: number) => {
    navigate(
      routes.studentFeesInvoice
        .replace(":id", id || "")
        .replace(":invoiceId", invoiceId.toString())
    );
  };

  const renderActionDropdown = (
    invoiceRow: any,
    handleCollectFeeSingle: any,
    isCreating: boolean,
    isVerifying: boolean
  ) => {
    const isPending = invoiceRow.status !== "completed";
    const invoiceId = invoiceRow.id;
    const partial = invoiceRow.status === "partial";
    const isStudentActive = student?.status === "active";

    return (
      <div className="dropdown">
        <button className="btn btn-light btn-sm" data-bs-toggle="dropdown">
          <i className="ti ti-dots-vertical"></i>
        </button>
        <ul className="dropdown-menu">
          <li>
            <Link
              className="dropdown-item"
              to={`${routes.studentFeesInvoice
                .replace(":id", id || "")
                .replace(":invoiceId", invoiceId.toString())}`}
            >
              <i className="ti ti-file-invoice me-2"></i>
              View Invoice
            </Link>
          </li>

          {isStudentActive && isPending && (
            <>
              {!partial && (
                <li>
                  <Link
                    className="dropdown-item"
                    to={`${routes.studentFeesDiscount
                      .replace(":id", id || "")
                      .replace(":invoiceId", invoiceId.toString())}`}
                  >
                    <i className="ti ti-discount-2 me-2"></i>
                    Apply Discount
                  </Link>
                </li>
              )}
              <li>
                <button
                  className="dropdown-item"
                  disabled={isCreating || isVerifying}
                  onClick={() => handleCollectFeeSingle(invoiceRow)}
                >
                  <i className="ti ti-cash me-2"></i>
                  Collect Fee
                </button>
              </li>
            </>
          )}
        </ul>
      </div>
    );
  };

  // Extract student info
  const student = studentResponse?.data?.student;
  const courseName =
    invoiceRows.length > 0 ? invoiceRows[0].courseName : "Not Available";

  const handleCollectSelectedFees = async () => {
    if (
      !student?.id ||
      !student?.center.id ||
      selectedInvoices.length === 0 ||
      student?.status !== "active"
    )
      return;

    const selectedRows = invoiceRows.filter((row) =>
      selectedInvoices.includes(row.id)
    );

    // Calculate total pending amount for all selected invoices
    const totalAmount = selectedRows.reduce((sum, row) => {
      const paidAmount =
        row.student_payments && row.student_payments.length > 0
          ? row.student_payments.reduce(
            (paymentSum, payment) =>
              payment.payment_status === "completed"
                ? paymentSum + payment.amount
                : paymentSum,
            0
          )
          : 0;

      const pendingAmount = row.payable - paidAmount;
      return sum + pendingAmount;
    }, 0);

    // Navigate to PaymentDetails with necessary props
    navigate(routes.paymentFeeDetails, {
      state: {
        student,
        invoices: selectedInvoices,
        totalAmount,
      },
    });
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <StudentBreadcrumb studentId={id} />
          </div>
          <div className="row">
            <StudentSidebar />
            <div className="col-xxl-9 col-xl-8">
              <div className="row">
                <div className="col-md-12">
                  {/* Navigation Tabs */}
                  <ul className="nav nav-tabs nav-tabs-bottom mb-4">
                    <li>
                      <Link
                        to={`${routes.studentDetail.replace(":id", id || "")}`}
                        className="nav-link"
                      >
                        <i className="ti ti-school me-2" />
                        Student Details
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentAttendanceDetail.replace(
                          ":id",
                          id || ""
                        )}`}
                        className="nav-link"
                      >
                        <i className="ti ti-calendar-due me-2" />
                        Attendance
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentFees.replace(":id", id || "")}`}
                        className="nav-link active"
                      >
                        <i className="ti ti-report-money me-2" />
                        Fees
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={`${routes.studentResult.replace(":id", id || "")}`}
                        className="nav-link"
                      >
                        <i className="ti ti-bookmark-edit me-2" />
                        Results
                      </Link>
                    </li>
                  </ul>

                  {/* Course Fee Details Card */}
                  <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between">
                      <h4 className="mb-0">Course Fee Details</h4>
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-sm btn-outline-primary me-2"
                          onClick={() =>
                            navigate(
                              `${routes.billingSection.replace(
                                ":id",
                                id || ""
                              )}`
                            )
                          }
                        >
                          <i className="ti ti-calculator me-2"></i>
                          Billing Overview
                        </button>

                        {selectedInvoices.length > 0 && (
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={handleCollectSelectedFees}
                            disabled={
                              isCreating ||
                              isVerifying ||
                              student?.status !== "active"
                            }
                          >
                            <i className="ti ti-cash me-2"></i>
                            {isCreating || isVerifying
                              ? "Processing..."
                              : "Collect Selected Fees"}
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="card-body">
                      {/* Course Summary */}
                      <div className="row mb-4">
                        <div className="col-md-6">
                          <div className="d-flex align-items-center mb-3">
                            <div className="flex-shrink-0">
                              <span className="avatar avatar-md bg-light-primary rounded">
                                <i className="ti ti-book fs-18"></i>
                              </span>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h6 className="mb-0">Course</h6>
                              <small className="text-muted">{courseName}</small>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-center mb-3">
                            <div className="flex-shrink-0">
                              <span className="avatar avatar-md bg-light-success rounded">
                                <i className="ti ti-cash fs-18"></i>
                              </span>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h6 className="mb-0">Total Fee</h6>
                              <small className="text-muted">
                                ₹{summary.totalAmount.toLocaleString()}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Fee Levels Table */}
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="thead-light">
                            <tr>
                              {/* <th>
                                <input
                                  type="checkbox"
                                  onChange={(e) => handleSelectAll(e.target.checked)}
                                  aria-label="Select all"
                                />
                              </th> */}
                              <th>Level</th>
                              <th>Due Date</th>
                              <th>Fee Type</th>
                              <th>Amount</th>
                              <th>Discount</th>
                              <th>Payable</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {invoiceRows.length > 0 ? (
                              invoiceRows.map((row) => {
                                return (
                                  <tr key={row.id}>
                                    <td
                                      onClick={() => handleStageClick(row.id)}
                                      style={{ cursor: "pointer" }}
                                      className="text-primary"
                                    >
                                      <div className="d-flex align-items-center">
                                        <span>
                                          {row.type === "registrationfee"
                                            ? "Registration"
                                            : row.stageName}
                                        </span>
                                      </div>
                                    </td>
                                    <td>{row.dueDate}</td>
                                    <td>
                                      <span
                                        className={`badge badge-soft-${row.type === "registrationfee"
                                          ? "primary"
                                          : "success"
                                          }`}
                                      >
                                        {row.type === "registrationfee"
                                          ? "Registration Fee"
                                          : "Course Fee"}
                                      </span>
                                    </td>
                                    <td>₹{row.amount.toLocaleString()}</td>
                                    <td>₹{row.discount.toLocaleString()}</td>
                                    <td>₹{row.payable.toLocaleString()}</td>
                                    <td>
                                      <span
                                        className={`badge badge-soft-${row.status === "completed"
                                          ? "success"
                                          : row.status === "partial"
                                            ? "info"
                                            : "warning"
                                          }`}
                                      >
                                        <i className="ti ti-circle-filled fs-5 me-1"></i>
                                        {row.status === "completed"
                                          ? "Paid"
                                          : row.status === "partial"
                                            ? "Partial"
                                            : "Pending"}
                                      </span>
                                    </td>
                                    <td>
                                      {renderActionDropdown(
                                        row,
                                        handleCollectFeeSingle,
                                        isCreating,
                                        isVerifying
                                      )}
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr style={{ height: "300px" }}>
                                <td colSpan={8} className="align-middle">
                                  <div className="d-flex align-items-center justify-content-center h-100">
                                    <div className="text-center">
                                      <div className="mb-3">
                                        <i className="ti ti-file-invoice fa-3x text-primary"></i>
                                      </div>
                                      <h4 className="mb-2">
                                        Invoices Not Generated
                                      </h4>
                                      <p className="text-muted mb-4">
                                        It looks like invoices have not been
                                        generated for this student yet.
                                      </p>
                                      <button
                                        className="btn btn-primary"
                                        onClick={() => {
                                          navigate(routes.generateInvoices);
                                        }}
                                      >
                                        <i className="ti ti-square-rounded-plus me-2"></i>
                                        Generate Invoices
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}

                            {/* Summary Row */}
                            {invoiceRows.length > 0 && (
                              <tr className="table-dark">
                                <td className="bg-dark text-white" colSpan={3}>
                                  <strong>Total</strong>
                                </td>
                                <td className="bg-dark text-white">
                                  <strong>
                                    ₹{summary.totalAmount.toLocaleString()}
                                  </strong>
                                </td>
                                <td className="bg-dark text-white">
                                  <strong>
                                    ₹{summary.totalDiscount.toLocaleString()}
                                  </strong>
                                </td>
                                <td className="bg-dark text-white">
                                  <strong>
                                    ₹{summary.totalPayable.toLocaleString()}
                                  </strong>
                                </td>
                                <td
                                  className="bg-dark text-white"
                                  colSpan={2}
                                ></td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <StudentModals />
    </>
  );
};

export default StudentFees;
